import React, { useState } from 'react';
import ContentBox from '../../common/ContentBox';
import { Box, Divider, FormControl, ITheme, InputLabel, Link, MenuItem, Select, Typography, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';
import { useAppSelector } from '../../../store/reducers/store';
import { useTranslation } from 'react-i18next';
import CollapsableReports from './components/CollapsableReports';
import { ReportType } from '../../../models/Portfolio';
import TableReports from './components/TableReports';

const ReportsDataRoomTab: React.FC = () => {
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t } = useTranslation();
    const [selectedFund, setSelectedFund] = useState(portfolio?.funds[0].id);
    const theme = useTheme() as ITheme;

    if (portfolio === undefined) {
        return <></>;
    }
    const onFundChange = (id: number) => {
        setSelectedFund(id);
    }

    const selectedFundItem = portfolio.funds.filter(f => f.id === selectedFund)[0];

    return <>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ height: "40px"}}>
                    <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsReportsPortfolioReports')}</Typography>
                    <Link component={NavLink} to={AUTHENTICATED_ROUTES.PORTFOLIO_DETAILS_REPORTS_ROUTE.replace(':id', `${portfolio.id}`).replace(':type', "all")} sx={{ textDecoration: "underline", color: theme.palette.leo.primary.blue[300]}}>{t('PortfolioDetailsReportsPortfolioReportsSeeAlls')}</Link>
                </Box>
                <Divider sx={{ margin: "0 -32px" }} />
                <CollapsableReports title={t('PortfolioDetailsReportsPortfolioReportsAnouncements')} reports={portfolio.reports.filter(r => r.type === ReportType.Announcement)} />
                <Divider />
                <CollapsableReports title={t('PortfolioDetailsReportsPortfolioReportsQuarterlyReports')} reports={portfolio.reports.filter(r => r.type === ReportType.QuarterlyReport)} />
                <Divider />
            </Box>
        </ContentBox>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ height: "40px"}}>
                    <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsReportsPortfolioFundsReports')}</Typography>
                    <FormControl variant="standard" sx={{border: `1px solid ${theme.palette.primary.main}`, borderRadius: "8px"}}>
                        <InputLabel sx={{ padding: "6px 0 0 12px", fontSize: "10px", zIndex: 1, color: theme.palette.leo.type[900]}}>Select Fund</InputLabel>
                        <Select variant='outlined' value={selectedFund} onChange={(e) => onFundChange(e.target.value as number)} sx={{
                            fontSize: "10px", "& .MuiSelect-select": { padding: "12px 0 4px 10px", fontSize: "10px", color: theme.palette.common.black  }
                        }}>
                            {portfolio.funds.map(f => <MenuItem value={f.id} key={`fund${f.id}`}>{f.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
                <Divider sx={{ margin: "0 -32px" }} />
                <CollapsableReports title={selectedFundItem.name} defaultOpened reports={selectedFundItem.reports} />
            </Box>
        </ContentBox>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ height: "40px"}}>
                    <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsReportsPortfolioDataRoom')}</Typography>
                    <Link component={NavLink} to={AUTHENTICATED_ROUTES.PORTFOLIO_DETAILS_REPORTS_ROUTE.replace(':id', `${portfolio.id}`).replace(':type', "datarooms")} sx={{ textDecoration: "underline", color: theme.palette.leo.primary.blue[300]}}>{t('PortfolioDetailsReportsPortfolioDataRoomSeeAlls')}</Link>
                </Box>
                <Divider sx={{ margin: "0 -32px" }} />
                <TableReports reports={portfolio.reports.filter(r => r.type === ReportType.DataRoom)} />
            </Box>
        </ContentBox>
    </>;
}

export default ReportsDataRoomTab;